// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__Q_igE","header":"MessagesList_header__2V2WX","chat":"MessagesList_chat__26_eq"};